import React, { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import './updatePrompt.css';

const CURRENT_VERSION = process.env.REACT_APP_VERSION;

function UpdatePrompt() {
  const intl = useIntl();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const check = () => {
      fetch('/meta.json?_=' + Date.now())
        .then(res => res.json())
        .then(meta => {
          if (meta.version && meta.version !== CURRENT_VERSION) {
            setVisible(true);
          }
        })
        .catch(() => {});
    };

    check();
    const id = setInterval(check, 60000);
    return () => clearInterval(id);
  }, []);

  const update = () => {
    if (window.caches) {
      caches.keys().then(keys => {
        keys.forEach(k => caches.delete(k));
      });
    }
    setVisible(false);
    window.location.reload();
  };

  if (!visible) return null;

  return (
    <div className="update-prompt">
      <div className="update-prompt-content">
        <div className="update-prompt-icon">
          <svg
            width="40"
            height="40"
            viewBox="0 0 24 24"
            fill="#3ca0ed"
            aria-hidden="true"
          >
            <path d="m23 12-2.44-2.78.34-3.68-3.61-.82-1.89-3.18L12 3 8.6 1.54 6.71 4.72l-3.61.81.34 3.68L1 12l2.44 2.78-.34 3.69 3.61.82 1.89 3.18L12 21l3.4 1.46 1.89-3.18 3.61-.82-.34-3.68zm-10 5h-2v-2h2zm0-4h-2V7h2z" />
          </svg>
        </div>
        <div className="update-prompt-text">
          <p className="update-title">
            {intl.formatMessage({ id: 'updatePrompt.title' })}
          </p>
          <p className="update-description">
            {intl.formatMessage({ id: 'updatePrompt.description' })}
          </p>
        </div>
        <button onClick={update}>
          {intl.formatMessage({ id: 'updatePrompt.button' })}
        </button>
      </div>
    </div>
  );
}

export default UpdatePrompt;
